import Skeleton from "@mui/material/Skeleton";
import { Box } from "@mui/material";

export default function ListSkeleton({ numRows }: { numRows: number }) {
  const rows = [];
  for (let i = 0; i < numRows; i++) {
    rows.push(<Skeleton animation="wave" height="36px" key={i} />);
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      {rows}
    </Box>
  );
}
